export var PAGEVIEW_EV_TYPE = 'pageview';
export var SESSION_EV_TYPE = 'session';
export var JS_ERROR_EV_TYPE = 'js_error';
export var HTTP_EV_TYPE = 'http';
export var RESOURCE_ERROR_EV_TYPE = 'resource_error';
export var RESOURCE_EV_TYPE = 'resource';
export var CUSTOM_EV_TYPE = 'custom';
export var PERFORMANCE_METRIC_EV_TYPE = 'performance';
export var PERFORMANCE_TIMING_EV_TYPE = 'performance_timing';
export var LONG_TASK_EV_TYPE = 'performance_longtask';
export var BLANK_SCREEN_EV_TYPE = 'blank_screen';
export var ACTION_EV_TYPE = 'action';
export var HEATMAP_EV_TYPE = 'heatmap';
//# sourceMappingURL=index.js.map